import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8 1a1 1 0 0 0-2 0v1.4h-.5A2.7 2.7 0 0 0 2.8 5c0 .5.1 1.1.5 1.6a2.7 2.7 0 0 0 1.7 1L6 8v1.7H4.3a1 1 0 1 0 0 2H6V13a1 1 0 1 0 2 0v-1.3h.5c1.6 0 2.6-1.2 2.7-2.5a2.6 2.6 0 0 0-2.2-3H8V4.3h1.7a1 1 0 0 0 0-2H8zM6 4.5h-.5c-.4 0-.7.3-.7.7s.2.6.5.7H6zM8 8v1.5h.5c.2 0 .4 0 .5-.2l.2-.5-.1-.4-.4-.3H8Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Payment = { render };
export {
  Payment as default,
  render
};
//# sourceMappingURL=Payment.svg.js.map
